module.exports = __webpack_public_path__ + "img/MEDIA050.a98ab383.jpg";